import {Component, OnInit, inject} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventsManager} from 'src/app/services/events.manager';
import {GeocoderResponseModel} from 'src/app/models/geocoder-response.model';
import {StateInterface} from 'src/app/interfaces/state.interface';
import {FormsModule} from '@angular/forms';
import {NgIf, NgFor} from '@angular/common';

@Component({
  selector: 'app-state-selection',
  templateUrl: './state-selection.component.html',
  styleUrl: './state-selection.component.scss',
  imports: [NgIf, FormsModule, NgFor]
})

export class StateSelectionComponent implements OnInit {
  public ngbActiveModal = inject(NgbActiveModal);
  public eventsManager = inject(EventsManager);

  public timeMessage: string = '';
  public state: StateInterface = {name:'', value:'', abbr:''};
  public stateName: string = 'none';
  public allowSave: boolean = false;
  public stateNotAllowed: boolean = false;
  public chooseState: boolean = false;

  public point: google.maps.LatLngLiteral = {
    lat: 0,
    lng: 0
  };
  public position: any = '';

  public ngOnInit() {
    this.geolocate();
    this.getTime();
  }

  public geolocate() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition( (position) => {
        this.position = position;
        this.point.lat = position.coords.latitude;
        this.point.lng = position.coords.longitude;
        this.eventsManager.isLocationOff = false;
        this.allowSave = true;
        this.codeLatLng(this.point);
      }, () => {
        this.getStateError();
      });
    } else {
      this.eventsManager.isLocationConfirmPage = false;
      this.eventsManager.isLocationOff = true;
    }
  }

  public getStateError() {
    this.eventsManager.isLocationConfirmPage = false;
    this.eventsManager.isLocationOff = true;
    this.allowSave = false;
  }

  public setChooseState() {
    this.chooseState = true;
  }

  public codeLatLng(location: google.maps.LatLngLiteral): Promise<GeocoderResponseModel> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({'location': location}, (results, status) => {
        const response = new GeocoderResponseModel(status, results);
        if (status == google.maps.GeocoderStatus.OK) {
          if (!(results) || results[1]) {
            results?.forEach((addy) => {
              if (addy.address_components[0].types[0] == 'administrative_area_level_1') {
                this.state.name = addy.address_components[0].long_name;
                this.state.value = addy.address_components[0].long_name;
                this.state.abbr = addy.address_components[0].short_name;
                this.setState({
                  target: {
                    value: this.state.abbr
                  }
                });
              }
            });
          }
        }
        resolve(response);
      });
    });
  }

  public getTime() {
    const today = new Date();
    const curHr = today.getHours();

    if (curHr < 12) {
      this.timeMessage = 'Good Morning';
    } else if (curHr < 18) {
      this.timeMessage = 'Good Afternoon';
    } else {
      this.timeMessage = 'Good Evening';
    }
  }

  public setState(event: any) {
    if (this.eventsManager.isStateAllowed(event.target.value)) {
      this.stateName = event.target.value;
      this.stateNotAllowed = false;
      this.allowSave = true;
      this.state = this.eventsManager.lookUpState(event.target.value);
    } else {
      this.allowSave = false;
      this.stateNotAllowed = true;
      this.state = this.eventsManager.lookUpState(event.target.value);
    }
  }

  public dismissState() {
    this.setChooseState();
    this.stateName = 'none';
  }

  public confirmState() {
    if (this.eventsManager.isLocationOff && this.stateName !== 'none') {
      this.state = this.eventsManager.lookUpState(this.stateName);
    }
    if (this.state.name !== '') {
      sessionStorage['state'] = JSON.stringify(this.state);
      this.eventsManager.getPlanOptions.emit();
      this.ngbActiveModal.close();
    }
  }
}
